import { reportPermissions } from '../../helpers/permissions'

const reports = [
  {
    title: 'Reports',
    icon: 'BarChartIcon',
    enableFeature: true,
    children: [
      {
        title: 'E-Channel Reports',
        enableFeature: true,
        children: [
          {
            title: 'E-Channel Transactions',
            route: 'e-channel-transactions-report',
            hasPermission: 'VIEW_ECHANNEL_REPORT',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Financial Reports',
        enableFeature: true,
        children: [
          {
            title: 'Balance Sheet',
            route: 'balance-sheet-report',
            hasPermission: 'VIEW_BALANCE_SHEET_REPORT',
            enableFeature: true,
          },
          {
            title: 'Chart of Accounts',
            route: 'chart-of-account',
            hasPermission: 'VIEW_CHART_OF_ACCOUNT_REPORT',
            enableFeature: true,
          },
          {
            title: 'Profit/Loss',
            route: 'profit-loss-report',
            hasPermission: 'VIEW_PROFIT_OR_LOSS_REPORT',
            enableFeature: true,
          },
          {
            title: 'Trial Balance',
            route: 'trial-balance-report',
            hasPermission: 'VIEW_TRIAL_BALANCE_REPORT',
            enableFeature: true,
          },
          // {
          //   title: 'Periodic Trial Balance',
          //   route: 'periodic-trial-balance-report',
          //   hasPermission: 'VIEW_TRIAL_BALANCE_REPORT',
          // },
        ],
      },
      {
        title: 'Credit & Loan Reports',
        enableFeature: true,
        children: [
          {
            title: 'Overdraft Report',
            route: 'overdraft-report',
            hasPermission: 'OVERDRAFT_REPORT',
            enableFeature: true,
          },
          {
            title: 'Loan and Advances',
            route: 'loan-and-advances',
            hasPermission: 'LOAN_AND_ADVANCES_REPORT',
            enableFeature: true,
          },
          {
            title: 'Loan Tracking',
            route: 'loan-tracking-report',
            hasPermission: 'LOAN_TRACKING_REPORT',
            enableFeature: true,
          },
          {
            title: 'Loan Repayment Expectation',
            route: 'loan-repayment-expectation-report',
            hasPermission: 'LOAN_REPAYMENT_REPORT',
            enableFeature: true,
          },
          {
            title: 'Closed Loan Report',
            route: 'closed-loan-report',
            hasPermission: 'VIEW_CLOSED_ACCOUNTS',
            enableFeature: true,
          },
          {
            title: 'Disbursed Loan Report',
            route: 'disbursed-loan-report',
            hasPermission: 'DISBURSED_LOAN_REPORT',
            enableFeature: true,
          },
          {
            title: 'Loan Collections Report',
            route: 'loan-collections-report',
            hasPermission: 'LOAN_COLLECTIONS_REPORT',
            enableFeature: true,
          },
          {
            title: 'Remita Collections Report',
            route: 'remita-collections-report',
            hasPermission: 'VIEW_REMITA_COLLECTIONS_REPORT',
            enableFeature: true,
          },
          // {
          //   title: 'On-Lending Report',
          //   route: 'on-lending-report',
          //   hasPermission: 'VIEW_SUBSCRIPTION_INVOICE', // change when available
          //   enableFeature: true,
          // },
        ],
      },
      {
        title: 'Credit Provisioning',
        enableFeature: true,
        children: [
          {
            title: 'Loan Provisioning',
            route: 'loan-provisioning',
            hasPermission: 'VIEW_LOAN_PROVISIONING',
            enableFeature: true,
          },
          {
            title: 'Overdraft Provisioning',
            route: 'overdraft-provisioning',
            hasPermission: 'VIEW_OVERDRAFT_PROVISIONING',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Operational Reports',
        enableFeature: true,
        children: [
          {
            title: 'Account Balance Report',
            route: 'customer-account-balance-report',
            hasPermission: 'ACCOUNT_BALANCE_REPORT',
            enableFeature: true,
          },
          {
            title: 'Account Balance Movement',
            route: 'account-balance-movement-report',
            hasPermission: 'ACCOUNT_BALANCE_MOVEMENT_REPORT',
            enableFeature: true,
          },
          {
            title: 'Customer Account Balance History Report',
            route: 'customer-account-balance-history-report',
            hasPermission: 'ACCOUNT_HISTORY_REPORT',
            enableFeature: true,
          },
          {
            title: 'Deposit Balance Report',
            route: 'deposit-balance-report',
            hasPermission: 'DEPOSITS_BALANCE_REPORT',
            enableFeature: true,
          },
          {
            title: 'Daily Till Balance Report',
            route: 'daily-till-balance-report',
            hasPermission: 'DAILY_TILL_BALANCE_REPORT',
            enableFeature: true,
          },
          {
            title: 'Fixed Deposit Balance Report',
            route: 'fixed-deposit-balance-report',
            hasPermission: 'FIXED_DEPOSITS_REPORT',
            enableFeature: true,
          },
          {
            title: 'GL Balance History Report',
            route: 'gl-balance-history-report',
            hasPermission: 'GL_HISTORY_REPORT',
            enableFeature: true,
          },
          {
            title: 'Savings Accrual History Report',
            route: 'savings-accrual-history-report',
            hasPermission: 'SAVINGS_ACCRUAL_HISTORY_REPORT',
            enableFeature: true,
          },
          {
            title: 'Loan Accrual History Report',
            route: 'loan-accrual-history-report',
            hasPermission: 'LOAN_ACCRUAL_HISTORY_REPORT',
            enableFeature: true,
          },
          {
            title: 'Fixed Deposit Accrual History Report',
            route: 'fixed-deposit-accrual-history-report',
            hasPermission: 'FIXED_DEPOSIT_ACCRUAL_HISTORY_REPORT',
            enableFeature: true,
          },
          {
            title: 'Overdraft Accrual History Report',
            route: 'overdraft-accrual-history-report',
            hasPermission: 'OVERDRAFT_ACCRUAL_HISTORY_REPORT',
            enableFeature: true,
          },
          {
            title: 'Active Account Report',
            route: 'active-account-report',
            hasPermission: 'VIEW_ACTIVE_ACCOUNTS_REPORT',
            enableFeature: true,
          },
          {
            title: 'VAT & WHT Report',
            route: 'vat-wht-report',
            hasPermission: 'VAT_AND_WHT_REPORT',
            enableFeature: true,
          },
          {
            title: 'Newly Opened Account',
            route: 'newly-opened-account-report',
            hasPermission: reportPermissions.ACCOUNT_CREATION_REPORT,
            enableFeature: true,
          },
          {
            title: 'BVN/NIN Compliance Report',
            route: 'bvn-nin-compliance-report',
            hasPermission: reportPermissions.VIEW_COMPLIANCE_REPORT,
            enableFeature: true,
          },
          {
            title: 'Download Manager',
            route: 'download-manager',
            hasPermission: reportPermissions.VIEW_REPORT_DOWNLOADS,
            enableFeature: true,
          },
          {
            title: 'Marketers Performance Report',
            route: 'marketers-performance-report',
            hasPermission: reportPermissions.VIEW_MARKETERS_PERFORMANCE_REPORT,
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Posting Reports',
        enableFeature: true,
        children: [
          {
            title: 'Customer Account History Report',
            route: 'customer-account-history-report',
            hasPermission: 'ACCOUNT_HISTORY_REPORT',
            enableFeature: true,
          },
          {
            title: 'CallOver Report',
            route: 'transaction-callover-report',
            hasPermission: 'TRANSACTION_CALLOVER_REPORT',
            enableFeature: true,
          },
          {
            title: 'EOD Transaction Report',
            route: 'eod-transaction-report',
            hasPermission: 'END_OF_DAY_TRANSACTION_REPORT',
            enableFeature: true,
          },
          {
            title: 'GL History Report',
            route: 'gl-history-report',
            hasPermission: 'GL_HISTORY_REPORT',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Regulatory Reports',
        enableFeature: true,
        children: [
          {
            title: 'ICAD Report',
            route: 'icad-report',
            hasPermission: 'ICAD_REPORT',
            enableFeature: true,
          },
          {
            title: 'Credit Bureau Report',
            route: 'credit-bureau-report',
            hasPermission: 'EXPORT_CREDIT_BUREAU_REPORT',
            enableFeature: true,
          },
          {
            title: 'NDIC Report',
            route: 'ndic-report',
            hasPermission: 'EXPORT_NDIC_REPORT',
            enableFeature: true,
          },
          {
            title: 'CBN Report',
            route: 'cbn-report',
            hasPermission: 'EXPORT_CBN_REPORT',
            enableFeature: true,
          },
          {
            title: 'Anti-Money Laundering',
            route: 'nfiu-report',
            hasPermission: reportPermissions.NFIU_REPORT,
            enableFeature: true,
          },
          {
            title: 'PEP Report',
            route: 'pep-report',
            hasPermission: reportPermissions.VIEW_PEP_REPORT,
            enableFeature: true,
          },
          {
            title: '3-Tiered KYC Report',
            route: 'three-tiered-kyc-report',
            hasPermission: reportPermissions.THREE_TIERED_KYC_REPORT,
            enableFeature: true,
          },
        ],
      },
    ],
  },
]

export default reports
